import tour from '../../../images/Project-Images/tour-booking.png'
import allinone from '../../../images/Project-Images/allinone.png'
import Ride from '../../../images/Project-Images/wow-riders.png'
import sports from '../../../images/Project-Images/sports-mania.png'
import ticket from '../../../images/Project-Images/online plane ticket.png'
import food from '../../../images/Project-Images/food master.png'
import bank from '../../../images/Project-Images/svn bank.png';
import music from '../../../images/Project-Images/hard music.png';
import fancy from '../../../images/Project-Images/fancy slider.png';
import penguin from '../../../images/Project-Images/penguin svn.png';
import web from '../../../images/Project-Images/svn personal web.png';
import cart from '../../../images/Project-Images/shopping cart.png';

const ProjectData = [
    {
        id: 1,
        name: 'Tour Event Book',
        image: tour,
        description: '',
        live: 'https://tour-service-1e6e5.web.app/',
        github: 'https://github.com/svn5969/tour-event-booking-client',
        category: ['react', 'node','mongodb','express']
    },

    {
        id: 2,
        name: 'AllinOne Valley',
        image: allinone,
        description: '',
        live: 'https://allinone-valley.web.app/',
        github: 'https://github.com/svn5969/allinone-valley-client',
        category: ['react', 'node','mongodb']
    },

    {
        id: 3,
        name: 'WoW Ride',
        image: Ride,
        description: '',
        live: 'https://react-auth-a09.web.app/',
        github: 'https://github.com/svn5969/wow-riders',
        category: ['react']
    },

    {   id: 4,
        name: 'Sports Mania',
        image: sports,
        description: '',
        live: 'https://focused-stonebraker-c165b8.netlify.app/',
        github: 'https://github.com/svn5969/sports-mania',
        category: ['react','api']
    },

    {
        id: 5,
        name: 'Online Plane Ticket',
        image: ticket,
        description: '',
        live: 'https://svn5969.github.io/online-plane-ticket/',
        github: 'https://github.com/svn5969/online-plane-ticket',
        category: ['js','html','css']
    },

    {   id: 6,
        name: 'Food Master',
        image: food,
        description: '',
        live: 'https://svn5969.github.io/svn-food-master/',
        github: 'https://github.com/svn5969/svn-food-master',
        category: ['js','api','html','css']
    },

    {
        id: 7,
        name: 'svn-bank',
        image: bank,
        description: '',
        live: 'https://svn5969.github.io/svn-bank/',
        github: 'https://github.com/svn5969/svn-bank',
        category: ['js','html','css']
    },

    {
        id: 8,
        name: 'Hard Music Search',
        image: music,
        description: '',
        live: 'https://svn5969.github.io/hard-rock-svn/',
        github: 'https://github.com/svn5969/hard-rock-svn',
        category: ['js','html','css']
    },

    {
        id: 9,
        name: 'Fancy Slider',
        image: fancy,
        description: '',
        live: 'https://svn5969.github.io/fancy-slider-svn/',
        github: 'https://github.com/svn5969/fancy-slider-svn',
        category: ['js','api','html','css']
    },
    {
        id: 10,
        name: 'Penguin Fashion',
        image: penguin,
        description: '',
        live: 'https://svn5969.github.io/shovon-penguin/',
        github: 'https://github.com/svn5969/shovon-penguin',
        category: ['html','css','bootstrap']
    },
    {
        id: 11,
        name: 'svn-personal-web',
        image: web,
        description: '',
        live: 'https://svn5969.github.io/sourav-personal-web/',
        github: 'https://github.com/svn5969/sourav-personal-web',
        category: ['html','css']
    },
    {
        id: 12,
        name: 'Shopping-cart',
        image: cart,
        description: '',
        live: 'https://svn5969.github.io/shopping-cart-by-svn/',
        github: 'https://github.com/svn5969/shopping-cart-by-svn',
        category: ['js','html','css']
    }
]

export default ProjectData;